/**
 * <BrandName /> — renders "Decorum Lifestyle" with a styled ™.
 * Use this in any UI chrome (headers, hero titles, dialogs, footers).
 * Pulls from src/lib/brand.ts so name + mark stay consistent.
 */
import { BRAND } from "@/lib/brand";

interface BrandNameProps {
  /** Render the ™ superscript. Default: true. */
  withMark?: boolean;
  /** Tailwind classes for the ™ superscript only. */
  markClassName?: string;
  /** Optional className applied to the wrapping <span>. */
  className?: string;
}

export function BrandName({
  withMark = true,
  markClassName = "ml-0.5 text-[0.55em] tracking-normal align-super",
  className,
}: BrandNameProps) {
  return (
    <span className={className}>
      {BRAND.nameNoMark}
      {withMark && <sup className={markClassName}>™</sup>}
    </span>
  );
}

export default BrandName;
